<div class="ui-g-12" style="padding: 0px;">
  <button
    class="float-right btn"
    pButton
    label="{{ 'WORK_HOUR.NEXT_LEASED_EMPLOYEE' | translate }}"
    (click)="onNextButtonClick()"
  ></button>
</div>
